document.addEventListener("DOMContentLoaded", () => {
  class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 800);

      const facetForm = this.querySelector("form");
      facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

      const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
      if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
    }

    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state
          ? event.state.searchParams
          : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      };
      window.addEventListener("popstate", onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
      document.querySelectorAll(".js-facet-remove").forEach((element) => {
        element.classList.toggle("disabled", disable);
      });
    }

    static async renderPage(searchParams, event, updateURLHash = true) {
      FacetFiltersForm.searchParamsPrev = searchParams;
      const sections = FacetFiltersForm.getSections();
      const countContainer = document.getElementById("ProductCount");
      const countContainerDesktop = document.getElementById(
        "ProductCountDesktop",
      );
      const loadingSpinners = document.querySelectorAll(
        ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
      );
      loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
      document
        .getElementById("ProductGridContainer")
        .querySelector(".collection")
        .classList.add("loading");
      if (countContainer) {
        countContainer.classList.add("loading");
      }
      if (countContainerDesktop) {
        countContainerDesktop.classList.add("loading");
      }

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
      });

      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersForm.filterData = [
            ...FacetFiltersForm.filterData,
            { html, url },
          ];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
          if (typeof initializeScrollAnimationTrigger === "function")
            initializeScrollAnimationTrigger(html.innerHTML);

          FacetFiltersForm.setListenersToSummary();        
        });
    }

    static setListenersToSummary() {
      // This event listener is specific to horizontal facet filters, which display filters in a popup layout in mobile.
      if (window.matchMedia("(max-width: 990px)").matches) {
        const facetSummary = document.querySelectorAll("#FacetsWrapperDesktop.facets__wrapper .facets__summary");
        const mainFiltersContainer = document.querySelector("#main-collection-filters");
        const searchFiltersContainer = document.querySelector("#main-search-filters");
        const filters = [mainFiltersContainer, searchFiltersContainer]

        if (facetSummary.length > 0) {
          facetSummary.forEach(summary => {
            summary.addEventListener("click", () => {

              filters.forEach(filter => {
                if (filter) {
                  const isOpen = summary.closest("details") ? summary.closest("details").hasAttribute("open") : false;

                  if (!isOpen) {
                    filter.classList.add("adjust-z-index");
                    document.body.classList.add("overflow-hidden");
                  }
                }
              })
            })
          })
        }
      }
    }

    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      if (typeof initializeScrollAnimationTrigger === "function")
        initializeScrollAnimationTrigger(html.innerHTML);
    }

    static renderProductGridContainer(html) {
      document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
        .parseFromString(html, "text/html")
        .getElementById("ProductGridContainer").innerHTML;

      const cardImages = document.querySelectorAll("#ProductGridContainer .card__media img")
      
      window.showImageLoading(cardImages)
      window.renderBannersAndSubfilters()
      window.showSectionBasedOnPageResult()

      document
        .getElementById("ProductGridContainer")
        .querySelectorAll(".scroll-trigger")
        .forEach((element) => {
          element.classList.add("scroll-trigger--cancel");
        });
    }

    static renderProductCount(html) {
      const container = new DOMParser().parseFromString(html, "text/html")

      if (container) {
        const count = container.getElementById('ProductCount');
        const productGrid = document.getElementById("product-grid");
        const countEleMobile = document.getElementById("ProductCount");
        const countEleDesktop = document.getElementById("ProductCountDesktop");

        // Update count element in collection banner too..
        const productCountElement = document.querySelector(".collection-hero__inner .products_count");
        const countElements = [countEleDesktop, countEleMobile, productCountElement];

        if (productGrid && count) {
          const showOnlyAvailable = productGrid.hasAttribute("data-results-count");

          countElements.forEach(ele => {
            if (ele) {
              ele.innerHTML = showOnlyAvailable ? 
                                    `${productGrid.getAttribute("data-results-count")} Products` : count.innerHTML

              ele.classList.remove("loading")
            }
          })
        }
      }

      // Hide loading spinner
      const loadingSpinners = document.querySelectorAll(
        ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
      );
      if (loadingSpinners) loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
    }

    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, "text/html");
      const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
      );
      const facetDetailsElementsFromDom = document.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
      );

      // Remove facets that are no longer returned from the server
      Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
        if (
          !Array.from(facetDetailsElementsFromFetch).some(
            ({ id }) => currentElement.id === id,
          )
        ) {
          currentElement.remove();
        }
      });

      const matchesId = (element) => {
        const jsFilter = event ? event.target.closest(".js-filter") : undefined;
        return jsFilter ? element.id === jsFilter.id : false;
      };

      const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
        (element) => !matchesId(element),
      );
      const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
        matchesId,
      );

      facetsToRender.forEach((elementToRender, index) => {
        const currentElement = document.getElementById(elementToRender.id);
        // Element already rendered in the DOM so just update the innerHTML
        if (currentElement) {
          document.getElementById(elementToRender.id).innerHTML =
            elementToRender.innerHTML;
        } else {
          if (index > 0) {
            const { className: previousElementClassName, id: previousElementId } =
              facetsToRender[index - 1];
            // Same facet type (eg horizontal/vertical or drawer/mobile)
            if (elementToRender.className === previousElementClassName) {
              document.getElementById(previousElementId).after(elementToRender);
              return;
            }
          }

          if (elementToRender.parentElement) {
            document
              .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
              .before(elementToRender);
          }
        }
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);

      if (countsToRender) {
        const closestJSFilterID = event.target.closest(".js-filter").id;

        if (closestJSFilterID) {
          FacetFiltersForm.renderCounts(
            countsToRender,
            event.target.closest(".js-filter"),
          );
          FacetFiltersForm.renderMobileCounts(
            countsToRender,
            document.getElementById(closestJSFilterID),
          );

          const newFacetDetailsElement =
            document.getElementById(closestJSFilterID);
          const newElementSelector = newFacetDetailsElement.classList.contains(
            "mobile-facets__details",
          )
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate =
            newFacetDetailsElement.querySelector(newElementSelector);

          const isTextInput = event.target.getAttribute("type") === "text";

          if (newElementToActivate && !isTextInput) newElementToActivate.focus();
        }
      }
    }

    static renderActiveFacets(html) {
      const activeFacetElementSelectors = [
        ".active-facets-mobile",
        ".active-facets-desktop",
      ];

      activeFacetElementSelectors.forEach((selector) => {
        const activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        document.querySelector(selector).innerHTML =
          activeFacetsElement.innerHTML;
      });

      FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
      const mobileElementSelectors = [
        ".mobile-facets__open",
        ".mobile-facets__count",
        ".sorting",
      ];

      mobileElementSelectors.forEach((selector) => {
        if (!html.querySelector(selector)) return;
        document.querySelector(selector).innerHTML =
          html.querySelector(selector).innerHTML;
      });

      document
        .getElementById("FacetFiltersFormMobile")
        .closest("menu-drawer")
        .bindEvents();
    }

    static renderCounts(source, target) {
      const targetSummary = target.querySelector(".facets__summary");
      const sourceSummary = source.querySelector(".facets__summary");

      if (sourceSummary && targetSummary) {
        targetSummary.outerHTML = sourceSummary.outerHTML;
      }

      const targetHeaderElement = target.querySelector(".facets__header");
      const sourceHeaderElement = source.querySelector(".facets__header");

      if (sourceHeaderElement && targetHeaderElement) {
        targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
      }

      const targetWrapElement = target.querySelector(".facets-wrap");
      const sourceWrapElement = source.querySelector(".facets-wrap");

      if (sourceWrapElement && targetWrapElement) {
        const isShowingMore = Boolean(
          target.querySelector("show-more-button .label-show-more.hidden"),
        );
        if (isShowingMore) {
          sourceWrapElement
            .querySelectorAll(".facets__item.hidden")
            .forEach((hiddenItem) =>
              hiddenItem.classList.replace("hidden", "show-more-item"),
            );
        }

        targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
      }
    }

    static renderMobileCounts(source, target) {
      const targetFacetsList = target.querySelector(".mobile-facets__list");
      const sourceFacetsList = source.querySelector(".mobile-facets__list");

      if (sourceFacetsList && targetFacetsList) {
        targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
      }
    }

    static updateURLHash(searchParams) {
      history.pushState(
        { searchParams },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
      );
    }

    static getSections() {
      return [
        {
          section: document.getElementById("product-grid").dataset.id,
        },
      ];
    }

    createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
      FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
      event.preventDefault();

      window.scrollTo({top : 0, behavior: "smooth"}); // Scroll to top of the page

      const sortFilterForms = document.querySelectorAll(
        "facet-filters-form form",
      );
      if (event.target && event.target.classList.contains("mobile-facets__checkbox")) {
        const searchParams = this.createSearchParams(
          event.target.closest("form"),
        );
        this.onSubmitForm(searchParams, event);
      } else {
        const forms = [];
        const isMobile =
          event.target.closest("form").id === "FacetFiltersFormMobile";

        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (
              form.id === "FacetSortForm" ||
              form.id === "FacetFiltersForm" ||
              form.id === "FacetSortDrawerForm"
            ) {
              forms.push(this.createSearchParams(form));
            }
          } else if (form.id === "FacetFiltersFormMobile") {
            forms.push(this.createSearchParams(form));
          }
        });
        this.onSubmitForm(forms.join("&"), event);
      }
    }

    onActiveFilterClick(event) {
      event.preventDefault();
      FacetFiltersForm.toggleActiveFacets();
      const url =
        event.currentTarget.href.indexOf("?") == -1
          ? ""
          : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
      FacetFiltersForm.renderPage(url);
    }
  }

  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define("facet-filters-form", FacetFiltersForm);
  FacetFiltersForm.setListeners();

  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll("input").forEach((element) => {
        element.addEventListener("change", this.onRangeChange.bind(this));
        element.addEventListener("keydown", this.onKeyDown.bind(this));
      });
      this.setMinAndMaxValues();
    }

    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }

    onKeyDown(event) {
      if (event.metaKey) return;

      const pattern =
        /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
      if (!event.key.match(pattern)) event.preventDefault();
    }

    setMinAndMaxValues() {
      const inputs = this.querySelectorAll("input");
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
      if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
      if (minInput.value === "") maxInput.setAttribute("data-min", 0);
      if (maxInput.value === "")
        minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
    }

    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute("data-min"));
      const max = Number(input.getAttribute("data-max"));

      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }

  customElements.define("price-range", PriceRange);

  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      const facetLink = this.querySelector("a");
      facetLink.setAttribute("role", "button");
      facetLink.addEventListener("click", this.closeFilter.bind(this));
      facetLink.addEventListener("keyup", (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
      });
    }

    closeFilter(event) {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    }
  }

  customElements.define("facet-remove", FacetRemove);

  // OPEN FACETES MOBILE DRAWER TO SHOW ALL THE FILTERS..
  class ShowAllFilters extends HTMLElement {
    constructor() {
      super()

      this.addEventListener("click", this.onClickHandler.bind(this))
    }

    onClickHandler(e) {
      e.preventDefault()

      const mobileFactes = document.querySelector(".mobile-facets__disclosure.disclosure-has-popup")

      if (mobileFactes) {
        const facetSummary = mobileFactes.querySelector(".mobile-facets__open-wrapper")
        const closeFacets = mobileFactes.querySelector(".mobile-facets__close")

        if (facetSummary && closeFacets) {
          const parentElement = facetSummary.parentElement
          const mainFiltersContainer = document.querySelector("#main-collection-filters")
          const searchFiltersContainer = document.querySelector("#main-search-filters")
          const filters = [mainFiltersContainer, searchFiltersContainer]

          if (parentElement) {
            parentElement.setAttribute("open", "true")
            parentElement.classList.add("menu-opening")
            document.body.classList.add("overflow-hidden")
            filters.forEach(filter => {
              if (filter) filter.classList.add("adjust-z-index")
            })
          }

          facetSummary.classList.remove("visibility-hidden")
          closeFacets.addEventListener("click", () => {
            document.body.classList.remove("overflow-hidden")
            facetSummary.classList.add("visibility-hidden")
            filters.forEach(filter => {
              if (filter) filter.classList.remove("adjust-z-index")
            })
          })
        }

        const currentTarget = this.getAttribute("data-facets")

        if (currentTarget) {
          const currentFacetsSummary = document.querySelector(`.mobile-facets__summary[data-label="${currentTarget}"]`)

          if (currentFacetsSummary) {
            currentFacetsSummary.click() // Trigger the mobile facet to show all the values when mobile drawer is open
          }
        }
      }
    }
  }

  customElements.define("show-all-filters", ShowAllFilters)

  // CLOSE FACETS DISPLAY...
  class CloseFacets extends HTMLElement {
    constructor() {
      super()

      this.mainFiltersContainer = document.querySelector("#main-collection-filters")
      this.searchFiltersContainer = document.querySelector("#main-search-filters")
      this.filters = [this.mainFiltersContainer, this.searchFiltersContainer]
      this.detailsTag = this.closest(".disclosure-has-popup.facets__disclosure") || this.closest("details.mobile-facets__disclosure")

      this.addEventListener("click", this.closeFacetsPopup.bind(this))
    }

    closeFacetsPopup(e) {
      e.preventDefault()

      this.filters.forEach(filter => {
        if (filter) filter.classList.remove("adjust-z-index")
      })

      if (this.detailsTag) {
        this.detailsTag.classList.remove("menu-opening")
        this.detailsTag.removeAttribute("open")
      }
      document.body.classList.remove("overflow-hidden")
    }
  }

  customElements.define("close-facets", CloseFacets)
})

// CUSTOM SORT-BY...
class CustomSortBy extends HTMLElement {
  constructor() {
    super();

    // Element references
    this.mainCollectionFilters = document.querySelector("#main-collection-filters");
    this.mainSearchFilters = document.querySelector("#main-search-filters");
    this.stickySortButton = document.querySelector(".sticky-filters-and-sortby .sticky-sortby");
    this.sortBySelect = this.closest(".linked-with-custom-sort");
    this.select = this.sortBySelect ? this.sortBySelect.querySelector(".facet-filters__sort") : null
    this.form = this.closest("#FacetFiltersForm");
    this.options = this.querySelectorAll(".sortOption");
    this.closeBtn = this.querySelector("#closeSortDrawer");
    this.body = document.body;
    this.filters = [this.mainCollectionFilters, this.mainSearchFilters];

    this.init();
    this.attachEvents();
  }

  init() {
    this.body.classList.remove("overflow-hidden")

    const defaultSort = document.querySelector(".facet-filters__sort")

    if (defaultSort) {
      const selectedOption = Array.from(this.options).find(opt => opt.dataset.value === defaultSort.value)

      this.options.forEach(opt => opt.classList.remove("selected"))
      if (selectedOption) selectedOption.classList.add("selected")
    }

    if (this.options.length > 0 && this.form && this.select) {

      this.options.forEach(option => {
        option.addEventListener("click", () => {
          this.select.value = option.dataset.value;
          this.form.dispatchEvent(new Event("input"));
        });
      });
    }
  }

  highlightSelectedOption() {

  }

  attachEvents() {
    // Open Sort Drawer
    if (this.stickySortButton) {
      this.stickySortButton.addEventListener("click", () => {
        this.body.classList.add("overflow-hidden");
        this.toggleCustomSortBy(true);
        this.adjustFiltersZIndex(true);
      });
    }

    // Close Sort Drawer
    if (this.closeBtn) this.closeBtn.addEventListener("click", () => this.closeSortByDrawer());
    this.addEventListener("click", (e) => {
      if (!e.target.closest(".sortby-inner-wrapper")) this.closeSortByDrawer();
    });
  }

  closeSortByDrawer() {
    this.body.classList.remove("overflow-hidden");
    this.toggleCustomSortBy(false);
    this.adjustFiltersZIndex(false);
  }

  toggleCustomSortBy(active) {
    this.classList.toggle("active", active);
  }

  adjustFiltersZIndex(add) {
    this.filters.forEach(filter => {
      if (filter) {
        filter.classList.toggle("adjust-z-index", add);
      }
    });
  }
}

customElements.define("custom-sortby", CustomSortBy);